import { MediaDTO, MediaModel } from "@/entities/Media";

import { shallowRef } from "vue";
import useAPIRequest from "@/composables/useAPIRequest";

const fetchMediaQuery = `
*[
  _type == 'media'
  && slug.current == $slug
  && !(_id in path('drafts.**'))
  && defined(title)
  && defined(slug)
  && defined(type)
  && defined(premierDate)
  && defined(poster)
  && defined(body)
][0]
{
  _id,
  mediaId,
  title,
  originalTitle,
  "slug": slug.current,
  type,
  isFeatured,
  premierDate,
  "poster": poster.asset->url,
  year,
  directors,
  genres,
  countries,
  quality,
  ageRating,
  trailerUrl,
  playerUrl,
  assetsUrl,
  body,
    articles[]->{
    _id,
    title,
    date,
    image,
    "slug": slug.current,
  },
}`;

export default function useMedia() {
  const media = shallowRef<MediaModel | undefined>(undefined);

  const { fetch: _fetchMedia, requestState: requestStateMedia } =
    useAPIRequest<MediaDTO>();
  const fetchMedia = async (slug: string) => {
    media.value = undefined;
    await _fetchMedia(fetchMediaQuery, { slug });
    if (
      requestStateMedia.value.status === "ready" &&
      requestStateMedia.value.data
    ) {
      media.value = new MediaModel(requestStateMedia.value.data);
    }
  };

  return {
    fetchMedia,
    media,
    requestStateMedia,
  };
}
